import { motion } from 'framer-motion';
import { Layers, BookOpen } from 'lucide-react';

interface HeaderProps {
  onGalleryClick: () => void;
}

export default function Header({ onGalleryClick }: HeaderProps) {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="sticky top-0 z-40 glass-panel border-b-0"
    >
      <div className="max-w-6xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-lovable-red to-lovable-teal flex items-center justify-center shadow-lg shadow-lovable-red/20 group-hover:shadow-lovable-red/40 transition-shadow">
              <Layers className="w-4 h-4 text-white" />
            </div>
            <span className="text-xl font-semibold text-white tracking-tight">Moltable</span>
          </a>

          <nav className="flex items-center gap-2">
            <button
              onClick={onGalleryClick}
              className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-all"
            >
              Gallery
            </button>
            <a
              href="/skill.md"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-all flex items-center gap-1.5"
            >
              <BookOpen className="w-4 h-4" />
              Docs
            </a>
          </nav>
        </div>
      </div>
    </motion.header>
  );
}
